module.exports = __webpack_public_path__ + "img/logo.9ca86ec4.svg";